import * as React from 'react';
import './index.scss';
import { Modal, Select, Space } from 'antd';
import CustomTabs from '../../../../components/Tabs';
import SprintComponent from './sprintComponent';
import BoardComponent from './board';
import RenderFormItem from '../../../../components/Forms/FormItems';
import { ComboConfig, FormColumnConfig } from '../../../../interfaces/entity';
import { useLocation, useNavigate } from 'react-router-dom';
import IssueComponent from './issueComponent';
import { useDispatch } from 'react-redux';
import { constants } from '../../../../constants/common';
import ColumnSettings from './ColumnSettings';

const ProjectTask: React.FC = () => {
    const locations = useLocation();
    const [activeLocation] = React.useState(locations.pathname);
    const [selectedProject, setSelectedProject] = React.useState(null);
    const [activeTab, setActiveTab] = React.useState('board');
    const [selectedTask, setSelectedTask] = React.useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const configProject: {
        column: FormColumnConfig,
        combo: ComboConfig[]
    } = {
        column: {
            type: 'select',
            name: 'project',
            label: '',
            isCombo: true,
            selectProps: {
                placeholder: 'Select Project',
                onChange: (e) => {
                    onChanegProject(e)
                },
                style: { width: 200 }
            }
        },
        combo: [{
            api: '/projects',
            idKey: '_id',
            name: 'project',
            render: (e) => e.name
        }]
    }


    const onClickIssue = (e) => {
        console.log('clicked', e)
        setSelectedTask(e)
    }

    const tabs = [
        {
            key: `${selectedProject}/board`,
            label: 'Board',
            content: <BoardComponent onClickIssue={(e) => onClickIssue(e)} projectId={selectedProject} />
        },
        {
            key: `${selectedProject}/backlog`,
            label: 'Backlog',
            content: <SprintComponent projectId={selectedProject} onClickIssue={(e) => onClickIssue(e)} />
        },
        {
            key: `${selectedProject}/issues`,
            label: 'Issues',
            content: <SprintComponent projectId={selectedProject} onClickIssue={(e) => onClickIssue(e)} showOldSprint={true} />
        },
        {
            key: `${selectedProject}/column-settings`,
            label: 'Column Settings',
            content: <ColumnSettings projectId={selectedProject} />
        }
    ]

    const onTabChanged = (key) => {
        setActiveTab(key)
    }

    const onChanegProject = (e) => {
        setSelectedProject(e)
        navigate(`${activeLocation}/${e}/board`)
        setActiveTab(`${e}/board`)
    }

    return (
        <>
            <Modal
                title={null}
                open={selectedTask}
                onCancel={() => {
                    setSelectedTask(null)
                    dispatch({ type: constants.REFRESH_DATA, reloadFor: 'Task' })
                }}
                footer={null}
                width={'80%'}
            >
                <IssueComponent selectedTask={selectedTask} />
            </Modal>
            <RenderFormItem column={configProject.column} combo={configProject.combo} />
            {selectedProject && <CustomTabs
                tabs={tabs}
                defaultActiveKey={activeTab}
                onTabChange={onTabChanged}
                routes={true}
            />
            }
        </>
    );
};

export default ProjectTask;
